'use strict';
import {Component, EventEmitter, Input, OnInit, Output, AfterViewInit} from '@angular/core';
import {AppConfigService} from '@ox/utils';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import {ConfirmationModalComponent} from '../confirmation-modal/confirmation-modal.component';
import {TranslateService} from '@ox/translate';
import {map} from 'rxjs';
import {TrackingService} from '@ox/data';
import {Vehicle} from '@ox/typings';


@Component({
  selector: 'webu-update-mileage',
  templateUrl: './update-mileage.component.html'
})
export class UpdateMileageComponent implements OnInit, AfterViewInit {
  @Input() activeVehicle: Vehicle; //from vehiclesnapshot
  @Input() showUpdateMileageError: boolean;
  @Input() activeVehicleMileageState: string;
  @Output() activeVehicleMileageStateChange = new EventEmitter<string>();//emitter to switch view in parent
  @Output() vehicleMileageUpdate = new EventEmitter<any>();
  public showConfirmationModal: boolean;
  public confirmationModalStyling = { // stylings to pass
    class: 'modal-confirmation',
    backdrop: true,
    ignoreBackdropClick: false
  };
  public confirmationModal = ConfirmationModalComponent;
  public confirmationOutputs = {
    close: new EventEmitter(),
    optionEvent: new EventEmitter()
  };
  public confirmationInputs = {
    firstOption: '',
    secondOption: '',
    titleText: '',
    confirmationText: '',
    id: 'editMilageConfirmationModal'
  };


  public language: any;
  public miles: any;
  public submitted: boolean;
  public invalidMileageError: boolean;
  public date: any;
  public updateMileageForm: FormGroup;
  public odometerAttributes = this.AppConfigService.fieldAttributes.vehicle.odometer;



  constructor(
    private AppConfigService: AppConfigService,
    private Fb: FormBuilder,
    private translateService: TranslateService,
    private trackingService: TrackingService
  ) {
    this.updateMileageForm = this.Fb.group({
      updateMileageInput: new FormControl('', [
        Validators.maxLength(this.odometerAttributes.maxlength),
        Validators.pattern(this.odometerAttributes.pattern.source),
        Validators.required
      ])
    });
  }

  ngOnInit(): void {
    this.language = this.AppConfigService.bml.lang;
    this.translateService.get(['updateMileageModal_cancel_confirmationFirstOptionText', 'updateMileageModal_cancel_confirmationSecondOptionText', 'updateMileageModal_cancel_confirmationTitle', 'updateMileageModal_cancel_confirmationText']).subscribe((translations) => {
      this.confirmationInputs.firstOption = translations.updateMileageModal_cancel_confirmationFirstOptionText;
      this.confirmationInputs.secondOption = translations.updateMileageModal_cancel_confirmationSecondOptionText;
      this.confirmationInputs.titleText = translations.updateMileageModal_cancel_confirmationTitle;
      this.confirmationInputs.confirmationText = translations.updateMileageModal_cancel_confirmationText;
    });
  }

  ngAfterViewInit() {
    this.updateMileageForm.controls['updateMileageInput'].setValue(this.activeVehicle.odometer);
  }


  sureClose() {
    this.showConfirmationModal = false;
    this.resetModal(true);
    this.activeVehicleMileageStateChange.emit('updateMileage');

  }

  notSureClose() {
    this.showConfirmationModal = false;
  }

  dismissUpdateModal() {
    if (this.updateMileageForm.dirty) {
      this.showConfirmationModal = true;
      this.confirmationOutputs.optionEvent.pipe(
        map((data: string) => {
          if (data === 'first') {
            this.sureClose();
          } else if (data === 'second') {
            this.notSureClose();
          }
        })
      ).subscribe();
    } else {
      this.activeVehicleMileageStateChange.emit('updateMileage');
    }
  }

  updateMileage() {
    this.miles = this.updateMileageForm.controls['updateMileageInput'].value;
    if (this.miles !== undefined && this.miles !== null && this.miles !== '') {
      //implement logic to attach the current date to the updated mileage entry.
      this.submitted = true;
      const mileage = parseInt(this.miles);
      if (mileage === 0 || this.miles > 999999) {
        this.invalidMileageError = true;
        this.trackingService.trackEvent(
          'event20',
          'activeVehicle.invalidMileageError'
        );
        return;
      }
      this.updateMileageSave(this.miles);
      this.showConfirmationModal = false;
      this.miles = null;
      this.invalidMileageError = false;
    }
  }


  resetModal(cancel: any) {
    this.miles = null;
    this.miles = this.activeVehicle.odometer;
    this.showUpdateMileageError = false;
    this.invalidMileageError = false;
    /* istanbul ignore else*/
    if (cancel)
      this.activeVehicleMileageStateChange.emit('updateMileage');
  }

  public updateMileageSave(miles: string) {
    if (this.updateMileageForm?.valid) {
      this.vehicleMileageUpdate.emit({odometer:miles,message:'updateSuccess'});
    }
  }
}


